import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  static get targets() {
    return ["frame"]
  }

  static get values() {
    return { domain: String, source: String, filters: Object, search: Boolean }
  }

  connect() {
    if (this.searchValue) {
      this.load()
    }
  }

  // Set filters passed from other stimulus controllers
  filter(event) {
    let filtersValue = this.filtersValue

    if (event.detail && event.detail.filters) {
      event.detail.filters.forEach((filter) => {
        filtersValue[filter.name] = filter.values.length === 0 ? null : filter.values
      })
    } else if (event.detail && event.detail.name) {
      filtersValue[event.detail.name] = event.detail.values.length === 0 ? null : event.detail.values
    }

    this.filtersValue = filtersValue
    this.load()
  }

  // Clear all the filters
  clearFilters() {
    this.filtersValue = {}
    this.load()
  }

  load() {
    let limit = 10
    let offset = 0

    let url = App.api.domainSearch({
      domain: this.domainValue,
      limit,
      offset,
      type: this.filtersValue.type,
      department: this.filtersValue.department,
      requiredField: this.filtersValue.required_field,
      jobTitles: this.filtersValue.job_titles,
      verificationStatus: this.filtersValue.verification_status,
      savedLeads: this.#savedLeadsFilterValue(),
      format: "html",
      source: "discover",
    })

    let form = TempFormHelper.create(
      url,
      "post",
      (form) => {
        let i = 0
        let e = 0

        if (this.filtersValue["location_included_continents"]) {
          Array.from(this.filtersValue["location_included_continents"]).forEach((value) => {
            i += 1
            TempFormHelper.addHiddenInput(form, `location[include][${i}][continent]`, value)
          })
        }

        if (this.filtersValue["location_excluded_continents"]) {
          Array.from(this.filtersValue["location_excluded_continents"]).forEach((value) => {
            e += 1
            TempFormHelper.addHiddenInput(form, `location[exclude][${e}][continent]`, value)
          })
        }

        if (this.filtersValue["location_included_business_regions"]) {
          Array.from(this.filtersValue["location_included_business_regions"]).forEach((value) => {
            i += 1
            TempFormHelper.addHiddenInput(form, `location[include][${i}][business_region]`, value)
          })
        }

        if (this.filtersValue["location_excluded_business_regions"]) {
          Array.from(this.filtersValue["location_excluded_business_regions"]).forEach((value) => {
            e += 1
            TempFormHelper.addHiddenInput(form, `location[exclude][${e}][business_region]`, value)
          })
        }

        if (this.filtersValue["location_included_countries"]) {
          Array.from(this.filtersValue["location_included_countries"]).forEach((value) => {
            i += 1
            TempFormHelper.addHiddenInput(form, `location[include][${i}][country]`, value)
          })
        }

        if (this.filtersValue["location_excluded_countries"]) {
          Array.from(this.filtersValue["location_excluded_countries"]).forEach((value) => {
            e += 1
            TempFormHelper.addHiddenInput(form, `location[exclude][${e}][country]`, value)
          })
        }

        if (this.filtersValue["location_included_states"]) {
          Array.from(this.filtersValue["location_included_states"]).forEach((value) => {
            i += 1
            TempFormHelper.addHiddenInput(form, `location[include][${i}][country]`, "US")
            TempFormHelper.addHiddenInput(form, `location[include][${i}][state]`, value)
          })
        }

        if (this.filtersValue["location_excluded_states"]) {
          Array.from(this.filtersValue["location_excluded_states"]).forEach((value) => {
            e += 1
            TempFormHelper.addHiddenInput(form, `location[exclude][${e}][country]`, "US")
            TempFormHelper.addHiddenInput(form, `location[exclude][${e}][state]`, value)
          })
        }

        if (this.filtersValue["location_included_cities"]) {
          Array.from(this.filtersValue["location_included_cities"]).forEach((value) => {
            i += 1
            const { country, state, city } = this.#parseCityValue(value)
            if (state.length > 0) {
              TempFormHelper.addHiddenInput(form, `location[include][${i}][state]`, state)
            }
            TempFormHelper.addHiddenInput(form, `location[include][${i}][country]`, country)
            TempFormHelper.addHiddenInput(form, `location[include][${i}][city]`, city)
          })
        }

        if (this.filtersValue["location_excluded_cities"]) {
          Array.from(this.filtersValue["location_excluded_cities"]).forEach((value) => {
            e += 1
            const { country, state, city } = this.#parseCityValue(value)
            if (state.length > 0) {
              TempFormHelper.addHiddenInput(form, `location[exclude][${e}][state]`, state)
            }
            TempFormHelper.addHiddenInput(form, `location[exclude][${e}][country]`, country)
            TempFormHelper.addHiddenInput(form, `location[exclude][${e}][city]`, city)
          })
        }
      },
      this.frameTarget,
    )

    form.requestSubmit()
  }

  #parseCityValue(cityValue) {
    const parts = cityValue.split(",")
    return {
      city: parts[0],
      state: parts[1] || "",
      country: parts[2] || "",
    }
  }

  #alreadySavedLeadsFilterValue() {
    if (!this.hasFiltersValue || !this.filtersValue.already_saved_leads) {
      return null
    }

    if (!Array.isArray(this.filtersValue.already_saved_leads)) {
      return this.filtersValue.already_saved_leads
    }

    return this.filtersValue.already_saved_leads.find((v) => v)
  }

  #savedLeadsFilterValue() {
    const alreadySavedLeadsFilterValue = this.#alreadySavedLeadsFilterValue()

    if (alreadySavedLeadsFilterValue === "show") {
      return "true"
    } else if (alreadySavedLeadsFilterValue === "hide") {
      return "false"
    }
  }
}
